module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Yrsa Sigurdardottir\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Yrsa SigurdardÓttir is an award-winning author of five children's novels and a division manager with one of Iceland's largest engineering firms. She lives with her family in Reykjavík, Iceland.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/OdgH27/tc-custom/9780061844812.jpg?1730586516510",
      "alt": "This image is the cover for the book Last Rituals, Thora Gudmundsdottir Novels"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Last Rituals, Thora Gudmundsdottir Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An Icelandic lawyer investigates the murder of a witchcraft-obsessed student in this “suspenseful, compelling and unique” thriller ("), _c('i', [_vm._v("Kirkus")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("When a wealthy German student is found murdered at a university in Reykjavík, the police waste no time making an arrest. But the young man’s body was disturbingly mutilated—the eyes cut out and strange symbols carved into his chest. Was this really the work of a local drug dealer? "), _c('br'), _c('br'), _vm._v("Believing the real killer to still be at large, the victim’s family hires local lawyer Thóra Gudmundsdóttir to investigate. It isn't long before Thóra and her associate, Matthew Reich, uncover the deceased student's obsession with Iceland's grisly history of torture, execution, and witch hunts. But there are contemporary horrors hidden in the shadows of these dark traditions. And for two suddenly endangered investigators, nothing is quite what it seems . . . and no one can be trusted.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0